module.exports = __webpack_public_path__ + "static/media/main.3e386309.jpg";